import moment from 'moment-timezone';

/**
 * Checks if a value is a valid timestamp.
 *
 * @param {number} value - The value to check.
 * @return {boolean} True if the value is a valid timestamp, false otherwise.
 */
export const isTimestamp = (value) => {
  if (typeof value === 'number' && !isNaN(value)) {
    const date = new Date(value);
    return date.getTime() === value;
  }

  return false;
};

/**
 * Converts a timestamp to a formatted date string (MM/DD/YYYY).
 *
 * @param {number} timestamp - The timestamp to convert.
 * @return {string} The formatted date string in MM/DD/YYYY format.
 */
export const convertTimestampToDate = (timestamp) => {
  const utcMoment = moment.utc(timestamp);
  //   const estMoment = utcMoment.tz('America/New_York');
  const formattedDate = utcMoment.format('MM/DD/YYYY');

  return formattedDate;
};
